// My FUND
export const GET_FUND = "GET_FUND";
export const GET_FUND_SUCCESS = "GET_FUND_SUCCESS";
export const GET_FUND_FAILURE = "GET_FUND_FAILURE";
export const GET_FUND_RESET = "GET_FUND_RESET";

// My BASIC FUND
export const GET_BASIC_FUND = "GET_BASIC_FUND";
